import { useEffect } from "react";
import { WelcomeAfterLogin } from "@/ui/components/WelcomeAfterLogin";
import { useWelcomeViewModel } from "@/viewModels/useWelcomeViewModel";

/**
 * WelcomePage Component
 *
 * STRICT MVVM PATTERN - ZERO LOGIC
 * - Pure rendering only
 * - Single useEffect(onMount, []) ONLY
 * - All logic in useWelcomeViewModel
 *
 * This page is displayed after first login to guide users
 * to either pair new items or view their collection.
 *
 * Business Rules (from ViewModel):
 * - If user has already seen welcome, redirects to trophy room
 * - Both actions navigate away and mark welcome as seen
 *
 * Note: WelcomeAfterLogin includes its own layout (MobileHeader, Footer, background)
 * so we don't wrap it in AuthLayout to avoid double headers/footers.
 *
 * Route: /welcome
 */
export const WelcomePage = () => {
  const { actions, onMount } = useWelcomeViewModel();

  // ONLY allowed useEffect - for mount lifecycle
  useEffect(onMount, []);

  return (
    <WelcomeAfterLogin
      onPairingClick={actions.goToPairing}
      onCollectionClick={actions.goToCollection}
    />
  );
};

export default WelcomePage;
